module.exports = __webpack_public_path__ + "static/media/galerija_2019 (13).dfa8c463.jpg";